import { NotifyHelper } from "../../../helpers/toast";
import { eDichVuHoSoActionsObj } from "../../action-types/dich-vu/IDichVuHoSoActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dichVuHoSoActions = {
  ...generateActions(eDichVuHoSoActionsObj, "DICH_VU_HO_SO"),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "DELETE_MANY_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "DELETE_MANY_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "IMPORT_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDichVuHoSoActionsObj,
    "DICH_VU_HO_SO",
    "IMPORT_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
